<template>
  <div class="header-wrap">
      <div class="header">
        <div class="logo">
          <a href="/">
            <img src="@/assets/img/logo.png" width="138px" height="39px" alt="">
          </a>
        </div>
        <div class="search-box">
          <input type="text" v-model="searchInput" placeholder="请输入搜索内容" @keyup.enter="searchSubmit">
          <img src="@/assets/img/search.png" @click="searchSubmit" alt="">
        </div>
        
        <div class="button" v-if="!login">
          <a href="javascript:;" @click="openLogin">登录</a>
          <a href="javascript:;" @click="openRegister">立即注册</a>
        </div>
        <div class="button" v-if="login">
          
          <span class="show-name"><b @click="downFile">传输助手下载</b></span>
          <span class="show-name" @click="openurl('/mydatabase')"><img src="@/assets/img/iconshujuku.png" width="16px"  alt="" /><b> 数据库</b></span>
          <span class="show-name" @click="openurl('/selectscipt')"><img src="@/assets/img/iconwuransuyuan.png" width="16px"  alt="" /><b> 污染溯源</b></span>
          <el-badge
            :value="messageCount"
            :hidden="messageCount > 0 ? false : true"
            class="item message"
          >
            <!-- <i
              class="el-icon-message-solid"
              style="font-size: 16px"
              @click="openMessageBox"
            ></i> -->
            <img src="@/assets/img/iconxiaoxi.png" :style="{'vertical-align': 'text-top','cursor':'pointer'}" width="16px"  @click="openMessageBox" alt="">
          </el-badge>
          <b :style="{'margin-right': '24px','display': 'inline-block','height': '24px','line-height': '24px','cursor':'pointer'}" @click="openMessageBox"> 消息</b>

          <el-popover
          :style="{'display': 'inline-block','height': '24px','line-height': '24px'}"
            placement="bottom"
            width="100"
            @hide="closePopover"
            trigger="click"
          >
            <!-- <div>{{ name }}</div> -->
            <div>
              <span @click="openUserInfo">个人信息</span>
            </div>
            <div>
              <span @click="openUpdatePwd">修改密码</span>
              <transition name="fade">
                <div class="update-password" v-if="updatePasswordFlag">
                  <div class="title">密码修改</div>
                  <div class="input-wrap">
                    <span>登录密码</span>
                    <div class="input-box">
                      <i class="iconfont icon-mima"></i>
                      <input
                        type="password"
                        v-model="oldPassword"
                        placeholder="请输入旧密码"
                      />
                    </div>
                  </div>
                  <div class="input-wrap">
                    <span>修改密码</span>
                    <div class="input-box">
                      <i class="iconfont icon-mima"></i>
                      <input
                        type="password"
                        v-model="newPassword"
                        placeholder="请输入新密码"
                      />
                    </div>
                    <div class="input-box">
                      <i class="iconfont icon-mima"></i>
                      <input
                        type="password"
                        v-model="newPasswordAgain"
                        placeholder="请再次输入新密码"
                      />
                    </div>
                  </div>
                  <div class="login-button" @click="updatePasswordSubmit">
                    <span>修改</span>
                  </div>
                </div>
              </transition>
            </div>
            <div @click="logout">退出登录</div>
            <el-badge is-dot :hidden="true" class="item" slot="reference" >
              <!-- <i style="font-size: 24px" class="el-icon-s-custom"></i> -->
              <span class="show-name-2"><img src="@/assets/img/iconren.png" :style="{'margin-right':'5px'}"  alt="" /><b> {{ name }} </b><i class="iconfont icon-bofang"></i></span>
            </el-badge>
          </el-popover>
          
        </div>
        
      </div>
  </div>
</template>

<script>
import api from "@/api/login";
import message from "@/api/message";
import CryptoJS from "crypto-js";
export default {
  name: "HeaderVue",
  props: {
    loginData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    login: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      updatePasswordFlag: false,
      name: sessionStorage.getItem("name"),
      token: "",
      oldPassword: "",
      newPassword: "",
      newPasswordAgain: "",
      messageCount: 0,
      searchInput: '',
      downFileUrl: 'https://3dfluor.cn/spectral-api/web/download/fluor-monitor.zip'
    };
  },
  computed: {
    validatePassword() {
  // 正则表达式匹配至少包含一个数字、一个小写字母、一个大写字母和一个特殊字符的字符串
        const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).+$/;
        
        // 使用正则表达式的test方法检查密码是否符合要求
        return regex.test(this.newPassword);
      },
  },
  methods: {
    downFile() {
      window.open(this.downFileUrl);
    },
    openUserInfo() {
      api.getUserInfo().then((res) => {
      if (res.code === 0) {
        // this.obj = res.data;
        this.$emit("openUserInfo",res.data);
      }
    });
      
    },
    cryptoJSPassword(password) { 
            const SECRET_KEY = "0123456789abcdef0123456789abcdef"; // 32字节(256位)密钥
            const IV = "abcdefghijklmnop"; // 16字节IV
            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            const iv = CryptoJS.enc.Utf8.parse(IV);
            const encrypted = CryptoJS.AES.encrypt(
                password,
                key,
                { 
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            return encrypted.toString()
        },
    updatePasswordSubmit() {
      if (!this.oldPassword) {
        this.$message({
          message: "旧密码不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.newPassword) {
        this.$message({
          message: "请输入新密码",
          type: "warning",
        });
        return;
      }
      if (!this.newPasswordAgain) {
        this.$message({
          message: "请再次新密码",
          type: "warning",
        });
        return;
      }

      if (this.newPasswordAgain !== this.newPassword) {
        this.$message({
          message: "两次密码不一致",
          type: "warning",
        });
        return;
      }
      if(this.newPassword.length < 8) {
        this.$message({
          message: "密码需要大于等于8位字符",
          type: "warning",
        });
        return;
      }
      if(!this.validatePassword) {
        this.$message({
          message: "密码需要包含数字、小写字母、大写字母和特殊字符的字符串",
          type: "warning",
        });
        return;
      }
      this.$confirm("本操作将修改密码，是否继续！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .updateOldPassword({
              
              oldPassword: this.cryptoJSPassword(this.oldPassword),
              password: this.cryptoJSPassword(this.newPassword),
            })
            .then((res) => {
              if (res.code === 0) {
                this.doLoginOut("修改成功,请重新登录")
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            message: "已取消",
          });
        });
    },
    openLogin() {
      this.$emit("openLogin");
    },
    openRegister() {
      this.$emit("openRegister");
    },
    openMessageBox() {
      this.$emit("openMessageBox");
    },
    openUpdatePwd() {
      this.oldPassword = "";
      this.newPassword = "";
      this.updatePasswordFlag = !this.updatePasswordFlag;
    },
    closePopover() {
      this.updatePasswordFlag = false;
    },
    doLoginOut(message) {
      api
        .logout()
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: message,
              type: "success",
            });
            sessionStorage.removeItem("login");
            sessionStorage.removeItem("name");
            sessionStorage.removeItem("token");
            if (this.$router.history.current.fullPath !== "/") {
              this.$emit("loginOut");
              this.$router.push({
                path: "/",
              });
            } else {
              this.$emit("loginOut");
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    logout() {
      this.$confirm("请确认，退出登录！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.doLoginOut("退出成功")
        })
        .catch(() => {
          this.$message({
            message: "已取消",
          });
        });
    },
    getMessageCount() {
      message.unReadCount().then((res) => {
        this.messageCount = res.data - 0;
      });
    },
    openurl(url) {
        if(this.$router.history.current.fullPath === url) {
            this.$router.go(0);
        } else {
            this.$router.push(url);
        }
    },
    UPDATE_NAME() {
      this.name = sessionStorage.getItem("name")
    },
    searchSubmit() {
      if(sessionStorage.getItem('login') === 'true') {
        if(this.searchInput) {
          this.$router.push({
            name: 'search',
            params: {
              name: this.searchInput
            }
          })
        } else {
          this.$message({
            message: '请输入要搜索的内容',
            type: 'warning'
          })
        }
      } else {
        this.openLogin()
      }
    }
  },
  created() {
    if (this.login) {
      this.name = sessionStorage.getItem("name");
      this.token = sessionStorage.getItem("token");
      this.getMessageCount();
    }
  },
  watch: {
    loginData: {
      handler(newValue) {
        if (newValue) {
          this.name = newValue.username;
          this.token = newValue.token;
        }
      },
    }
    
  },
  beforeDestroy() {
    // this.logout()
  },
};
</script>

<style lang="scss" scoped>
.header-wrap {
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);


  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding: 0 0 0 36px;

    .download-button {
      a {
        text-decoration: none;
        color: #000;
        font-weight: 600;
      }
    }

    .search-box {
      display: inline-block;
      width: 486px;
      height: 36px;
      border-radius: 34px;
      background: #EBEBEB;
      overflow: hidden;
      position: relative;
      input {
        display: inline-block;
        height: 36px;
        line-height: 36px;
        width: 100%;
        padding-left: 20px;
        border: none;
        background: none;
        font-size: 14px;
        
        &:focus {
          outline: none;
          border: none; 
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 25px;
        cursor: pointer;
        opacity: 0.8;
        &:hover {
          opacity: 1;
        }
        &:active {
          opacity: 1;
          scale: 1.05;
        }
      }
    }

    .logo {
      a {
        text-decoration: none;
        
        span {
          color: #065999;
          font-weight: bolder;
          font-size: 26px;
        }
      }
    }

    .el-button {
      margin-left: 30px;
    }

    .button {
      a {
        display: inline-block;
        color: #000;
        text-decoration: none;
        width: 100px;
        height: 64px;
        font-size: 14px;
        text-align: center;
        line-height: 64px;
        &:last-of-type {
          background: #0366F1;
          color: #fff;
        }
        // &.header-menu {
        //   color: #00a8ff;
        //   &:hover {
        //     color: #00b7ff;
        //   }
        //   &:active {
        //     color: #409eff;
        //   }
        // }

      }
      i {
        cursor: pointer;
      }

      .message {
        // margin-right: 10px;
      }

      span {
        margin-right: 24px;
        img {
          vertical-align: sub;
        }
      }

      b {
        font-size: 14px;
      }
    }
  }
}
.el-popover {
  a {
    color: #606266;
    text-decoration: none;
    display: inline-block;
    height: 100%;
    width: 100%;
  }

  div {
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
    position: relative;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* 标准语法 */
    border-radius: 2px;
    & > span {
      display: inline-block;
      height: 100%;
      width: 100%;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    // &:first-of-type {
    //   cursor: default;
    //   background: none;
    // }

    .update-password {
      width: 260px;
      padding: 10px 30px;
      background: #fff;
      position: absolute;
      top: 0;
      right: 111%;
      animation: fadeIn 1s ease;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      word-break: break-all;
      border-radius: 10px;
      .input-wrap {
        text-align: left;
        &:hover {
          background: none;
        }
      }
      .title {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
      }

      .input-box {
        margin-top: 2px;
        position: relative;

        div {
          text-align: left;
        }

        font-size: 16px;

        input {
          width: 100%;
          font-size: 14px;
          padding: 10px 40px;
          border: none;
          outline: none;
          background: #f5f5f5;
          border-radius: 5px;
        }

        i {
          color: #101010;
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translateY(-50%);
        }
      }

      .login-button {
        margin-top: 10px;
        span {
          display: block;
          padding: 5px 0;
          text-align: center;
          color: #fff;
          background: #00a8ff;
          border-radius: 5px;
          cursor: pointer;
        }
        &:hover {
          background: none;
        }
      }
    }
  }
}

.show-name,
.show-name-2 {
  // margin-left: 30px;
  font-size: 12px;
  cursor: pointer;
  i {
    color: #000;
    cursor: pointer;
    font-size: 12px;
    rotate: 90deg;
    display: inline-block;
  }

  
}

.show-name {
  display: inline-block;
  height: 24px;
  line-height: 24px;
}

.show-name-2 {
  // vertical-align: text-top;
  // b {
  //   vertical-align: top;
  // }
  height: 24px;
  display: flex;
  line-height: 24px;
}

.fly-menu {
  position: absolute;
  top: 50px;
  right: 30px;
  a {
        text-decoration: none;
        margin-left: 5px;
        font-size: 14px;
        &.header-menu {
          color: #00a8ff;
          &:hover {
            color: #00b7ff;
          }
          &:active {
            color: #409eff;
          }
        }

      }
}


@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>